import logo from './logo.svg';
import './App.css';
import MainScreen from './Components/MainScreen';
import './Components/Styles.css'; // Tell webpack that Button.js uses these styles

const App = () => {
  return (
    <MainScreen/>
  );
}

export default App;
